import { Buyer } from '@40seas/entities/buyers';
import { Checkout } from '@40seas/entities/checkout';
import { Omit, Partial, With } from '@40seas/entities/common';
import { z } from 'zod';

export class CreateCheckoutIntentDto extends With(
    Partial(Omit(Checkout, ['buyer'])),
    z.object({
        buyer: z.string().or(Buyer['schema'].partial()),
    }),
) {
    buyer: string | Partial<Buyer>;
}
